import * as React from "react";
const SvgFiRrDagger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dagger_svg__a)">
      <path
        fill="#062147"
        d="m19.41 5.996 4.296-4.288A1 1 0 1 0 22.294.292l-4.298 4.29-1.461-1.46A10.58 10.58 0 0 0 9 0a1 1 0 1 0 0 2c1.876 0 3.656.602 5.136 1.7l-7.024 7.032a32.6 32.6 0 0 0-6.074 8.403s-.964 1.938-.981 2.02a2.33 2.33 0 0 0 .63 2.16 2.33 2.33 0 0 0 2.16.63c.082-.018 2.02-.982 2.02-.982a32.6 32.6 0 0 0 8.404-6.075l7.024-7.034A8.6 8.6 0 0 1 22 15a1 1 0 1 0 2 0c0-2.724-1.025-5.286-2.877-7.267-.02-.023-1.714-1.737-1.714-1.737m-7.556 9.478a30.6 30.6 0 0 1-7.888 5.702L2.328 22a.34.34 0 0 1-.23-.1.34.34 0 0 1-.1-.23l.824-1.636a30.6 30.6 0 0 1 5.702-7.889l7.098-7.107 3.328 3.327-7.098 7.108z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dagger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDagger;
